import { useTranslations } from 'next-intl';

import type { ItemType } from '@/config/itemTypes';

interface ToolsProps {
  toolTypes: ItemType[];
  iconType?: string;
  isMobile?: boolean;
}

const Tools = ({ toolTypes, isMobile }: ToolsProps) => {
  const t = useTranslations();
  return (
    <section id="Tools-container" className="Section Tools">
      <h2 className="Section-heading">{t('DRWNG__MENU_TOOLS')}</h2>
      <div className="Section-inner">
        {toolTypes.map((item, index) => {
          return (
            <div
              className={`${isMobile ? 'Item-container' : ''} Item-tool`}
              key={index}
            >
              <div
                className={`Draggable-itemWrap Asset--${item.variation}`}
                // className={`Draggable-itemWrap Asset--shirt${isDragging ? ' Controls-img--base' : ''}`}
                draggable={isMobile ? 'false' : 'true'}
                data-name={item.name}
                data-label={t(`DRWNG__ITEM_${item.variation}`)}
                data-variation={item.variation}
                data-color={item.color}
                data-width={item.width}
                data-height={item.height}
                data-default-icon={item.defaultIcon.src}
                data-src={item.defaultIcon.src}
                data-font-color={item.fontColor}
              >
                <img src={item.button?.src || item.defaultIcon.src} alt="" />
              </div>
              {isMobile && <span>{t(`DRWNG__ITEM_${item.variation}`)}</span>}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Tools;
